export default __webpack_public_path__ + "static/media/sova-accounting_200_1-1.3d8288dd.png";